import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MissionService } from 'app/services/models/mission.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-mission-dialog',
  templateUrl: './mission-dialog.component.html',
  styleUrls: ['./mission-dialog.component.scss']
})
export class MissionDialogComponent implements OnInit {

  missions: any[] = [];
  missionName: string = '';
  editMode: boolean = false;
  selectedMissionId: number | null = null;

  constructor(
    private ngModal: NgbActiveModal,
    private missionService: MissionService,
    private toastr: ToastrService) { }

  async ngOnInit() {
    await this.getAllMission();
  }

  async getAllMission() {
    const data = await this.missionService.getAllMission();
    this.missions = data;
  }

  async saveMission() {
    if (!this.missionName.trim()) return;

    let res: any;

    if (this.editMode && this.selectedMissionId !== null) {
      res = await this.missionService.updateMission(this.selectedMissionId, this.missionName);
    } else {
      res = await this.missionService.createMission(this.missionName);
    }

    if (res.status === true) {
      this.toastr.success(res.message, 'Başarılı');
      this.closeModal(true);
    } else {
      this.toastr.error(res.message, 'Hata');
    }

    this.resetForm();
    await this.getAllMission();
  }

  editMission(mission: any) {
    this.editMode = true;
    this.selectedMissionId = mission.id;
    this.missionName = mission.name;
  }

  cancelEdit() {
    this.resetForm();
  }

  resetForm() {
    this.editMode = false;
    this.selectedMissionId = null;
    this.missionName = '';
  }

  closeModal(result: boolean = false) {
    this.ngModal.close(result);
  }
}
